/* * @Author: mikey.zhaopeng * @Date: 2025-05-02 21:54:04 * @Last Modified by:
mikey.zhaopeng * @Last Modified time: 2025-05-02 21:54:51 */扫码认证
<template>
  <div class="saomarenzheng">
    <el-dialog
      :visible.sync="dialogVisible"
      :lock-scroll="false"
      :modal-append-to-body="false"
      @closed="close"
    >
      <div class="content">
        <div class="title titleStyle">扫码认证</div>
        <div class="username">{{ itemData.name }}（{{ itemData.idNumber }}）</div>
        <div class="code">
          <vue-qr :margin="0" :text="itemData.authUrl" :size="160"></vue-qr>
        </div>
        <div class="desc">
          <span>使用</span>
          <span style="color: #0062ff">「支付宝账号」</span>
          <span>或</span>
          <span style="color: #0062ff">「微信账号」</span>
          <span>扫码完成认证</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
let js;
import vueQr from "vue-qr";
import userinfo from "@/mixins/userinfo.js";
export default {
  mixins: [userinfo],
  components: {
    vueQr,
  },
  data() {
    return {
      dialogVisible: false,
      itemData: {
        name: "",
        idNumber: "",
        idType: "",
        phone: "",
        authUrl: "",
      },
    };
  },
  created() {},
  computed: {},
  watch: {
    "user.name": {
      handler(newVal, oldVal) {
        if(newVal !== oldVal){
            this.close()
            this.dialogVisible = false;
            this.$emit("success")

        }
      }
    },
  },
  methods: {
    onshow(itemData) {
      this.itemData = itemData;
      this.dialogVisible = true;
      js = setInterval(() => {
        this.$store.dispatch("user/getAccount");
      }, 1000);
    },
    close() {
      js && clearInterval(js);
    },
  },
};
</script>

<style scoped lang="scss">
.saomarenzheng {
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 14px;
    .title {
      width: 100%;
    }
    .username {
      font-family: "Noto Sans SC";
      font-size: 14px;
      font-weight: 350;
      line-height: 22px;
      letter-spacing: 0px;

      font-variation-settings: "opsz" auto;
      color: #666666;
      margin-top: 16px;
    }
    .code {
      width: 180px;
      height: 180px;
      border-radius: 6px;

      background: #ffffff;

      box-sizing: border-box;
      border: 1px solid #eeeeee;

      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 14px;
    }
    .desc {
      font-family: "Noto Sans SC";
      font-size: 14px;
      font-weight: 350;
      line-height: 22px;
      letter-spacing: 0px;
      margin-top: 16px;
      font-variation-settings: "opsz" auto;
    }
  }
}
</style>
